import { render, staticRenderFns } from "./CategoryCascader.vue?vue&type=template&id=8f239616&scoped=true&"
import script from "./CategoryCascader.vue?vue&type=script&lang=js&"
export * from "./CategoryCascader.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCascader.vue?vue&type=style&index=0&id=8f239616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f239616",
  null
  
)

export default component.exports